import { atom } from "recoil";

export type TActionDrawer = "CART" | "WISHLIST" | "ACCOUNT" | "MENU" | null;

export const USE_ACTION_DRAWER = atom<TActionDrawer>({
  key: "USE_ACTION_DRAWER",
  default: null,
});
